import { all, put, call, takeEvery, select } from 'redux-saga/effects'
import { apiPaths } from '../../config'
import AlertSubscriptionAction from './actions'
import { alertSubscriptionSetState as setState } from '../actions'
import { http, notification } from '../../services'

const getUser = (state) => state.user
const getDevice = (state) => state.device
const getClinic = (state) => state.clinic

// API call to get a List of All Devices filtered by the current logged in Provider if a Provider is logged in, or unfiltered if Superadmin is logged in.
const getSMSSubscription = async (data, role) =>
  http
    .get(apiPaths[role].apiSMSSubscriptionList, data)
    .then((res) => res)
    .catch((e) => {
      const { response } = e
      const { data: resData } = response

      return resData
    })

const addNumberToSubscription = async (data, role) =>
  http
    .post(apiPaths[role].apiSMSSubscriptionAdd, data)
    .then((res) => res)
    .catch((e) => {
      const { response } = e
      notification.error(`Something went wrong`, `${response && response.data ? response.data : e}`)
      return []
    })

const disableSubscription = async (data, role) =>
  http
    .post(apiPaths[role].apiSMSSubscriptionDisable, data)
    .then((res) => {
      notification.success(`Success`, 'Alert Disabled')
      return res
    })
    .catch((e) => {
      const { response } = e
      notification.error(`Something went wrong`, `${response && response.data ? response.data : e}`)
      return []
    })

export function* ADD_NUMBER({ payload }) {
  yield put(setState({ AddNumberModalLoading: true }))
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  const response = yield call(addNumberToSubscription, payload, role)

  yield put(setState({ AddNumberModalLoading: false, modalVisibleAdd: false }))
  if (response === 'success') {
    yield call(GET_SUBSCRIPTION_LIST, { payload: {} })
  }
}
export function* DISABLE_SUBSCRIPTION({ payload }) {
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  const response = yield call(disableSubscription, payload, role)

  if (response === 'success') {
    yield call(GET_SUBSCRIPTION_LIST, { payload: {} })
  }
}
export function* GET_SUBSCRIPTION_LIST({ payload }) {
  yield put(setState({ loading: true }))

  payload.active = 0
  const { role } = yield select(getUser)
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  let subscriptionListDisabled = yield call(getSMSSubscription, payload, role)
  // window.log('subscriptionListInActive', subscriptionListInActive)
  payload.active = 1
  let subscriptionList = yield call(getSMSSubscription, payload, role)

  if (!Array.isArray(subscriptionList)) {
    notification.error(`No Data`, subscriptionList)
    subscriptionList = []
  }
  if (!Array.isArray(subscriptionListDisabled)) {
    subscriptionListDisabled = []
  }
  const { inventoryListingDevices } = yield select(getDevice)
  yield put(
    setState({
      loading: false,
      subscriptionList,
      subscriptionListDisabled,
      devices: inventoryListingDevices.data ? inventoryListingDevices.data : [],
    }),
  )
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(AlertSubscriptionAction.GET_SUBSCRIPTION_LIST, GET_SUBSCRIPTION_LIST),
    takeEvery(AlertSubscriptionAction.ADD_NUMBER, ADD_NUMBER),
    takeEvery(AlertSubscriptionAction.DISABLE_SUBSCRIPTION, DISABLE_SUBSCRIPTION),
  ])
}
